import { render } from "./IndexExplore.vue?vue&type=template&id=20d335a0"
import script from "./IndexExplore.vue?vue&type=script&lang=js"
export * from "./IndexExplore.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__